import script from "./NewList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewList.vue?vue&type=script&setup=true&lang=js"

import "./NewList.vue?vue&type=style&index=0&id=e4cf53b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4cf53b8"]])

export default __exports__